import React from 'react'
import classnames from 'classnames'
import { Icons } from '../../Shared/Icons'
import { Spinner } from '../../Shared/Spinner/Spinner'
import styles from './styles.module.scss'

interface AiDraftSuccessScreenProps {
  message: string
  subtitle: string
  type?: 'success' | 'declined'
  isLoading?: boolean
}

const AiDraftSuccessScreen: React.FC<AiDraftSuccessScreenProps> = ({
  message,
  subtitle,
  type = 'success',
  isLoading = false
}) => {
  const IconComponent = type === 'declined' ? Icons.CloseCircle : Icons.CheckCircle

  return (
    <div className={styles.successScreen} role="status" aria-live="polite">
      <div className={styles.checkmarkContainer}>
        <div
          className={classnames(styles.checkmark, {
            [styles.checkmarkDeclined]: type === 'declined'
          })}
          aria-hidden="true"
        >
          <IconComponent />
        </div>
      </div>
      <div className={styles.messageContainer}>
        <h2 className={styles.message}>{message}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        {isLoading && <Spinner classNames={styles.loadingSpinner} isLoading />}
      </div>
    </div>
  )
}

export default AiDraftSuccessScreen
